import React from "react";
import {
  IconApps,
  IconAppsBlue,
  IconBusinessMessages,
  IconBusinessMessagesBlue,
  IconContract,
  IconContractBlue,
  IconCorporateFare,
  IconCorporateFareBlue,
  IconCrown,
  IconCrownBlue,
  IconInboxText,
  IconInboxTextBlue,
  IconInventory2,
  IconInventory2Blue,
  IconSms,
  IconSmsBlue,
} from "assets/svg";

export const menuSeller = [
  {
    to: "/seller/dashboard",
    icon: <IconApps />,
    iconActive: <IconAppsBlue />,
    label: "ダッシュボード",
  },
  {
    to: "/seller/information",
    icon: <IconCorporateFare />,
    iconActive: <IconCorporateFareBlue />,
    label: "登録情報の管理",
  },
  {
    to: "/seller/list",
    icon: <IconInventory2 />,
    iconActive: <IconInventory2Blue />,
    label: "出品内容の管理",
  },
  {
    to: "/seller/transaction-status",
    icon: <IconBusinessMessages />,
    iconActive: <IconBusinessMessagesBlue />,
    label: "取引ステータスの管理",
  },
  {
    to: "/seller/past-list-history",
    icon: <IconContract />,
    iconActive: <IconContractBlue />,
    label: "過去の出品履歴の閲覧",
  },
  {
    to: "/seller/transaction-history",
    icon: <IconInboxText />,
    iconActive: <IconInboxTextBlue />,
    label: "取引履歴の閲覧",
  },
  {
    to: "/seller/global-ranking",
    icon: <IconCrown />,
    iconActive: <IconCrownBlue />,
    label: "全体ランキング",
  },
  {
    to: "/seller/conversation-inquiry",
    icon: <IconSms />,
    iconActive: <IconSmsBlue />,
    label: "お問い合わせ",
  },
];
